module.exports = __webpack_public_path__ + "static/img/reg_tesn_9v-1.8197d2e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/reg_tesn_9v-1.svg
// module id = xTYp
// module chunks = 0